import API from '@aws-amplify/api';
import { IEditRoleInput } from './EditRoleConstants';

export async function updateRole(roleId: string, role: IEditRoleInput) {
  try {
    const response = await API.put(import.meta.env.VITE_API_GATEWAY_NAME, `/roles/${roleId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      body: role,
      response: true,
    });

    return response.data;
  } catch {
    return Promise.reject();
  }
}
